import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const StarsBar = ({ size, value = 1 }) => (
  <div className={cx('rating-stars', `stars-${size}`)}>
    <div className="stars-fill" style={{ width: `${value * 100}%` }} />
  </div>
);

StarsBar.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default StarsBar;
